import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { H } from "deltoid/core/Blocks/Typography";
import Form from "deltoid/core/Form";
import MultipleFileUploader from "./MultipleFileUploader";
import { uiActions, dialogActions, dialogSelectors, manualUploadActions, toastActions } from "@store/ducks";
import UploadedFile from "./UploadedFile";
import ConfirmationDialog from "./ConfirmationDialog";

const MultipleFileUploadDialog = ({
  dialogProps,
  showToast,
  closeDialog,
  uploadMergeDocs,
  resetFilePathAndIDItem,
  loadUI,
  removeAllFiles,
}) => {
  const { modalTitle, documentCategoryId, documentTypeId, maxFileSizeLimit, uploadedDocument, setUploadedFile } =
    dialogProps;

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [rejectedFiles, setRejectedFiles] = useState(null);
  const [docUUID, setDocUUID] = useState(uploadedDocument ? uploadedDocument.uuid : null);

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { }, [uploadedFiles]);

  const removeFromList = (path) => {
    const copyOfUploadedFiles = [...uploadedFiles];
    const index = copyOfUploadedFiles.indexOf(uploadedFiles.find((uploadedFile) => uploadedFile.path == path));
    if (index > -1) {
      copyOfUploadedFiles.splice(index, 1);
    }
    setUploadedFiles(copyOfUploadedFiles);
  };

  const fileList = uploadedFiles.map((file) => {
    return (
      <li key={file.path}>
        <UploadedFile
          path={file.path}
          file={file}
          fileName={file.name}
          documentCategoryId={documentCategoryId}
          documentTypeId={documentTypeId}
          onFileRemove={removeFromList}
          setDocUUID={setDocUUID}
        />
      </li>
    );
  });

  const addFileData = (acceptedFiles) => {
    const newFiles = acceptedFiles
      .map((acceptedFile) => {
        if (!uploadedFiles.find((uploadedFile) => uploadedFile.path === acceptedFile.path)) return acceptedFile;
        else showToast("warning", "Warning", `${acceptedFile.name} has already been uploaded`);
        return false;
      })
      .filter((file) => {
        if (file == undefined) {
          return;
        } else return file;
      });
    setUploadedFiles([...uploadedFiles, ...newFiles]);
  };

  const mergeAttachments = () => {
    if (uploadedFiles.length > 0) {
      let fileData = [];
      setLoading(true);
      uploadMergeDocs(fileData, docUUID, (response) => {
        setLoading(false);
        resetFilePathAndIDItem();
        setUploadedFile(response);
        closeDialog();
        // loadUI();
      });
    } else {
      setLoading(false);
      showToast("warning", "Warning", `Please select a file to upload`);
    }
  };

  const submitCancelConfirmation = () => {
    if (uploadedFiles && Array.isArray(uploadedFiles) && uploadedFiles.length) {
      removeAllFiles((response) => {
        showToast("success", "Success", `Files were removed successfully.`);
        // setIsConfirmationOpen(false);
        closeDialog();
      });
    } else closeDialog();
  };

  return (
    <>
      <ConfirmationDialog className={!isConfirmationOpen ? `hideDiv` : ''}
        onNegativeClick={() => {
          setIsConfirmationOpen(false);
        }}
        onPositiveClick={() => {
          submitCancelConfirmation();
        }}
      />
      <div className={isConfirmationOpen ? `hideDiv` : `` + ` multi-mod-content-wrap`} data-testid="multipleFileUpload">
        <div className="mod-top-title-wrap">
          <H level={5} variant="bold" className="modal-heading">
            {modalTitle}
          </H>
          <div className="cross-icon-wrap" onClick={closeDialog}>
            <CrossIcon width="16px" height="16px" />
          </div>
        </div>
        <div className="mod-two-upload-form">
          <Form.Label id={`labelFrontSide`} className="loader-label">
            File Uploader
          </Form.Label>
          <MultipleFileUploader
            onFileDropAccepted={(acceptedFiles) => {
              addFileData(acceptedFiles);
            }}
            onFileDropRejected={() => { }}
            allowedFileExtensions="image/png, application/pdf, image/jpg, image/jpeg"
            maxFileSizeInMB={() => { }}
            onRemove={() => { }}
            disabled={false}
            multiple={true}
            uploadedDocument={null}
            uploaderState={"initial"}
            onUploadIconClick={null}
          />
          <div className="upload-item-description">jpg,jpeg, pdf, png less than {maxFileSizeLimit} MB</div>
        </div>
        <div className="multi-uploaded-files-wrap">
          <ul className="multi-uploaded-file-list">{fileList}</ul>
        </div>
      </div>
      <div className={isConfirmationOpen ? `hideDiv` : `` + `mod-btn-bot-row`}>
        <Form.Button
          variant="underlined"
          className="btn-cancel"
          onClick={() => {
            if (uploadedFiles && Array.isArray(uploadedFiles) && !uploadedFiles.length) {
              closeDialog();
            } else {
              // submitCancelConfirmation();
              setIsConfirmationOpen(true);
            }
          }}
        >
          Cancel Upload
        </Form.Button>
        <Form.Button
          variant="default"
          loading={loading}
          className="btn-upload"
          onClick={mergeAttachments}
          disabled={uploadedFiles && Array.isArray(uploadedFiles) && !uploadedFiles.length ? true : false}
        >
          {loading ? "Uploading..." : "Upload"}
        </Form.Button>
      </div>
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  showToast: (variant, title, content) =>
    dispatch(toastActions.show({ variant: variant, title: title, content: content })),
  openDialog: () => dispatch(dialogActions.open("multi-file-upload")),
  closeDialog: () => dispatch(dialogActions.close()),
  uploadMergeDocs: (fileData, docId, callback) =>
    dispatch(manualUploadActions.mergeMultipleFileAttachments(fileData, docId, callback)),
  resetFilePathAndIDItem: () => dispatch(manualUploadActions.resetFilePathAndIDItem()),
  loadUI: () => dispatch(uiActions.loadUI({})),
  removeAllFiles: (callback) => dispatch(manualUploadActions.removeAllAttachments(callback)),
});
const mapStateToProps = (state) => ({
  dialogProps: dialogSelectors.getProps(state),
});
export default connect(mapStateToProps, mapDispatchToProps)(MultipleFileUploadDialog);

const CrossIcon = ({ width, height }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8194 1.13739C12.0602 0.877324 12.0602 0.455117 11.8194 0.19505C11.4983 -0.0650167 11.097 -0.0650167 10.8562 0.19505L5.95987 5.05365L1.14381 0.19505C0.822742 -0.0650167 0.421405 -0.0650167 0.180602 0.19505C-0.0602007 0.455117 -0.0602007 0.877324 0.180602 1.13739L5.07692 5.99599L0.180602 10.8554C-0.0602007 11.1155 -0.0602007 11.5369 0.180602 11.7969C0.421405 12.0578 0.822742 12.0578 1.14381 11.7969L5.95987 6.93833L10.8562 11.7969C11.097 12.0578 11.4983 12.0578 11.8194 11.7969C12.0602 11.5369 12.0602 11.1155 11.8194 10.8554L6.92308 5.99599L11.8194 1.13739Z"
        fill="#3B3F46"
      />
    </svg>
  );
};
